import React, { useContext } from "react";
import "./MobileNav.scss";

// Font Awesome
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components
import { IonContent, IonFooter, IonHeader, IonItem, IonList, IonMenu, IonMenuButton, IonMenuToggle, IonToolbar } from "@ionic/react";
import moment from "moment";
import { withRouter } from "react-router";

// Context
import { AuthenticatedUserContext } from "../../../contexts/AuthenticatedUserContext";
import { useSettings } from "../../../contexts/SettingsContext";

// Utilities
import { useTranslation } from "react-i18next";
import { NavItems } from "../../../utils";
import { NavItem } from "../../../utils/NavItems";

const MobileNav: React.FC<any> = (props) => {
  const { member } = useContext(AuthenticatedUserContext);
  const isApproved = moment(member?.approved_at).isBefore();
  const navItems = NavItems();
  const { t } = useTranslation();
  const { settings } = useSettings();
  const { setShowSignOutConfirm } = useContext(AuthenticatedUserContext);

  // @ts-ignore
  return (
    <>
      <IonMenu side="start" menuId="mobileNav" contentId="main" className="mobile-nav">
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <div className="mobile-nav__header">
              <img src={settings?.brand?.img_path_app_header_logo || "assets/logo-white-icon.svg"} alt={`${t("instance")} Logo`} width="160px" />
              <IonMenuButton className="mobile-nav__menu-button" menu="mobileNav" autoHide={true} color="dark">
                <FontAwesomeIcon icon={faTimes} />
              </IonMenuButton>
            </div>
          </IonToolbar>
        </IonHeader>

        {isApproved && (
          <IonContent id="mobileNavContent" className="mobile-nav__content">
            <IonList lines="none">
              {navItems
                .filter((navItem) => navItem.showOnMenu && navItem.mobile)
                .map((navItem: NavItem, key: any) => (
                  <IonMenuToggle key={key}>
                    <IonItem routerLink={navItem.url} className={["mobile-nav__item", navItem.active ? "mobile-nav__item--selected" : ""].join(" ")}>
                      {navItem.title}
                    </IonItem>
                  </IonMenuToggle>
                ))}

              <IonItem
                button
                className="mobile-nav__item"
                onClick={() => {
                  setShowSignOutConfirm(true);
                }}
              >
                {t("signOut")}
              </IonItem>
            </IonList>
          </IonContent>
        )}

        <IonFooter className="mobile-nav__footer">
          <IonToolbar color="none">
            <IonMenuToggle>
              <IonItem lines="none" className="mobile-nav__item mobile-nav__account" routerLink="/account">
                {t("account")}
              </IonItem>
            </IonMenuToggle>
          </IonToolbar>
        </IonFooter>
      </IonMenu>
    </>
  );
};

export default withRouter(MobileNav);
